<template>
<div class="chapter">
<div class="inner_page">
<h2 class="AHD"><strong>Bake Me I’m Yours… Seasonal Push Pop Cakes</strong></h2>
<h3 class="BHD"><strong>MORE THAN 10 PUSH POP CAKE DESIGNS FOR SEASONAL CELEBRATIONS</strong></h3>
<h3 class="CH-AU"><strong>KATIE DEACON</strong></h3>
<div class="Image"><img alt="" src="OEBPS/images/logo.gif"/></div>
<h4 class="CHD"><strong><em><a href="http://www.stitchcraftcreate.co.uk/kitchen" target="_blank">www.stitchcraftcreate.co.uk/kitchen</a></em></strong></h4>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?586e4747